import { render, staticRenderFns } from "./razorPay.vue?vue&type=template&id=459e0764&scoped=true"
import script from "./razorPay.vue?vue&type=script&lang=js"
export * from "./razorPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459e0764",
  null
  
)

export default component.exports